/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConferenceModelListResult } from '../../models/conference-model-list-result';

export interface ApiConferenceGet$JsonOdataStreamingTrue$Params {
}

export function apiConferenceGet$JsonOdataStreamingTrue(http: HttpClient, rootUrl: string, params?: ApiConferenceGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
  const rb = new RequestBuilder(rootUrl, apiConferenceGet$JsonOdataStreamingTrue.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.streaming=true', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConferenceModelListResult>;
    })
  );
}

apiConferenceGet$JsonOdataStreamingTrue.PATH = '/api/conference';
